import { Checkbox } from "@ark-ui/react";
import type { ComponentProps } from "react";

export const ClickableChip = ({ ...props }: React.ButtonHTMLAttributes<HTMLButtonElement>) => {
  return <button type="button" {...props} />;
};

export const SelectableChip = ({
  selected,
  onSelect,
  className,
  children,
  ...props
}: Omit<ComponentProps<typeof Checkbox.Root>, "checked" | "onCheckedChange"> & {
  selected?: boolean;
  onSelect?: (selected: boolean) => void;
}) => {
  return (
    <Checkbox.Root
      checked={selected}
      onCheckedChange={(details) => onSelect?.(details.checked as boolean)}
      className="flex"
      {...props}
    >
      <Checkbox.Control asChild>
        <span className={className}>{children}</span>
      </Checkbox.Control>
      <Checkbox.HiddenInput />
    </Checkbox.Root>
  );
};

export const DefaultChip = ({ ...props }: React.HTMLAttributes<HTMLSpanElement>) => {
  return <span {...props} />;
};
